import { DialogContent, DialogTitle } from '@mui/material'
import Box from '@mui/material/Box'
import { CSSProperties, ReactNode } from 'react'

interface Props {
  title?: string
  children: ReactNode
}

export default function ModalLayout(props: Props) {
  return (
    <Box style={containerStyle}>
      {props.title && (
        <DialogTitle style={titleStyle}>{props.title}</DialogTitle>
      )}
      <DialogContent style={contentStyle}>{props.children}</DialogContent>
    </Box>
  )
}

const containerStyle: CSSProperties = {
  padding: '20px',
}

const titleStyle: CSSProperties = {
  marginBottom: '8px',
}

const contentStyle: CSSProperties = {
  padding: '0 16px',
}
